import { render, staticRenderFns } from "./Interfacelicensing.vue?vue&type=template&id=411d6e28&scoped=true"
import script from "./Interfacelicensing.vue?vue&type=script&lang=js"
export * from "./Interfacelicensing.vue?vue&type=script&lang=js"
import style0 from "./Interfacelicensing.vue?vue&type=style&index=0&id=411d6e28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411d6e28",
  null
  
)

export default component.exports